export default __webpack_public_path__ + "static/media/information.ff50e673.svg";